<template>
    <div>
        <StepHeader
            :subtitle="subtitle"
            :description="description"
        />
        <StepBtnGroup
            class="mt-6 step-group format"
            :fields="fields"
            :selectedValue="selectedFormat"
            :layout="'card'"
            @select-value="selectFormat"
        />
    </div>
</template>

<script>
    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import StepBtnGroup from '@/components/myHabiteoStudio/steps/components/StepBtnGroup';

    export default {
        name: 'StepFormat',
        components: {
            StepHeader,
            StepBtnGroup
        },
        props: {
            subtitle: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            forms: {
                type: Array,
                required: true
            },
            selectedFormat: {
                type: Number,
                required: false
            }
        },
        computed: {
            fields() {
                return this.$props.forms[0].inputs[0].fields;
            }
        },
        methods: {
            selectFormat(format) {
                this.$props.forms[0].inputs[0].value = format;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepFormat.vue